<div class="modal-checkout-pagarme-overlay" *ngIf="isShowModal">

  <div class="modal-checkout-pagarme-container" *ngIf="stepForm === 1 && !typePayment">
    <button class="close-btn-modal" (click)="handleCloseAllModal()"><mat-icon>close</mat-icon></button>
    <div class="modal-checkout-pagarme-header">
      <img src="assets/LogoDark.png" alt="Logo" class="modal-checkout-pagarme-logo">
    </div>
    <div class="modal-checkout-pagarme-body">
      <h2 class="modal-checkout-pagarme-title">Confirme seu e-mail de acesso</h2>
      <form class="modal-checkout-pagarme-form">
        <label for="email" class="modal-checkout-pagarme-label">E-mail</label>
        <input type="email" id="email" class="modal-checkout-pagarme-input" [value]="emailUser" required
          [(ngModel)]="emailUser" [ngModelOptions]="{standalone: true}" />

        <button type="button" class="modal-checkout-pagarme-button" (click)="handleStepOne()">CONFIRMAR</button>
      </form>
    </div>
  </div>
  <div class="select-billing-type-container" *ngIf="stepForm === 2 && !typePayment">

    <button class="close-btn-modal" (click)="handleCloseAllModal()"><mat-icon>close</mat-icon></button>
    <div class="div-cards-select-payment">
      <div class="select-billing-type-card" (click)="handleSelectCreditCard()">
        <div class="select-billing-type-icon">
          <img src="assets/logo-cartao-credito.png" alt="Ícone Cartão">
        </div>
        <h3 class="select-billing-type-title">Cartão</h3>
        <p class="select-billing-type-description">
          Realize o pagamento utilizando cartão de crédito.
        </p>
      </div>
      <div class="select-billing-type-card" (click)="handleSelectPix()">
        <div class="select-billing-type-icon">
          <img src="assets/Logo-Pix-Png.webp" alt="Ícone PIX">
        </div>
        <h3 class="select-billing-type-title">PIX</h3>
        <p class="select-billing-type-description">
          Realize o pagamento utilizando o PIX.
        </p>
      </div>
    </div>
  </div>
  <div class="payment-pix-container" *ngIf="typePayment === 'pix'">
    <button class="payment-pix-button-close" (click)="handleClosePixCardQrcode()"><mat-icon>close</mat-icon></button>
    <img src="/assets/LogoDark.png" alt="Logo Blick" class="payment-pix-logo" />
    <div class="payment-pix-card">
      <h1 class="payment-pix-title">Checkout</h1>
      <p class="payment-pix-description">
        Sua licença será liberada em até 5 minutos após o pagamento.
      </p>
      <img [src]="linkQrCode" alt="QR Code" class="payment-pix-qr-code" />
      <button class="payment-pix-button" (click)="handleCopyCode()">COPIAR CÓDIGO</button>
      <button class="payment-pix-back-button" (click)="handleClosePixCardQrcode()">VOLTAR</button>
    </div>
  </div>

  <div class="checkout-container" [ngClass]="{'card-data': stepCard === 2}" *ngIf="typePayment === 'credit-card'">
    <div class="checkout-steps">
      <button class="close-btn" (click)="handleCloseAllModal()"><mat-icon>close</mat-icon></button>
      <!-- Step 1: Endereço -->
      <div class="step" [ngClass]="{'active': stepCard === 1}" id="step-1" *ngIf="stepCard === 1">
        
        <h2>Informações de Endereço</h2>
        <form id="address-form">
          <div class="form-group">
            <label for="cep">CEP *</label>
            <input type="text" id="cep" placeholder="Digite seu CEP" required [(ngModel)]="dataCreditCard.endereco.cep" (keyup)="handleSearchCep()" [ngModelOptions]="{standalone: true}">
            <small class="error-message">Campo obrigatório</small>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="numero">Número</label>
              <input type="text" id="numero" placeholder="Digite o número" [(ngModel)]="dataCreditCard.endereco.numero" [ngModelOptions]="{standalone: true}">
            </div>
            <div class="form-group">
              <label for="bairro">Bairro</label>
              <input type="text" id="bairro" placeholder="Digite o bairro" [(ngModel)]="dataCreditCard.endereco.bairro" [ngModelOptions]="{standalone: true}">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="rua">Rua</label>
              <input type="text" id="rua" placeholder="Digite a rua" [(ngModel)]="dataCreditCard.endereco.rua" [ngModelOptions]="{standalone: true}">
            </div>
            <div class="form-group">
              <label for="cidade">Cidade</label>
              <input type="text" id="cidade" placeholder="Digite a cidade" [(ngModel)]="dataCreditCard.endereco.cidade" [ngModelOptions]="{standalone: true}">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="estado">Estado</label>
              <select id="estado" [(ngModel)]="dataCreditCard.endereco.estado" [ngModelOptions]="{standalone: true}">
                <option value="" disabled selected>Selecione</option>
                <option [value]="estado.sigla" *ngFor="let estado of estadosBrasil">{{estado.sigla}}</option>
              </select>
            </div>
          </div>
          <button type="button" class="next-btn" (click)="nextStepCard()">Continuar</button>
        </form>
      </div>

      <!-- Step 2: Dados do Cartão -->
      <div class="step"  [ngClass]="{'active': stepCard === 2, 'active-card': stepCard === 2}" id="step-2" *ngIf="stepCard === 2">
        <button class="close-btn" (click)="handleCloseAllModal()"><mat-icon>close</mat-icon></button>
        <h2>Dados do Cartão</h2>
        <!-- <div class="card-preview">
          <div class="card">
            <div class="card-details">
              <span>#### #### #### ####</span>
              <span>Nome Completo</span>
              <span>MM/AA</span>
            </div>
          </div>
        </div>
        <form id="payment-form">
          <div class="form-group">
            <label for="numero-cartao">Número do cartão *</label>
            <input type="text" id="numero-cartao" placeholder="Digite o número do cartão" required>
          </div>
          <div class="form-group">
            <label for="titular-cartao">Titular do cartão *</label>
            <input type="text" id="titular-cartao" placeholder="Digite o nome do titular" required>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="mes">Vencimento *</label>
              <select id="mes" required>
                <option value="" disabled selected>Mês</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="12">12</option>
              </select>
            </div>
            <div class="form-group">
              <select id="ano" required>
                <option value="" disabled selected>Ano</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label for="cvv">CVV *</label>
            <input type="text" id="cvv" placeholder="Digite o CVV" required>
          </div>
          <button type="submit" class="submit-btn">Assinar</button>
        </form> -->

        <div class="card-data-container">
          <div class="card-data-credit-card">
            <div class="card-data-chip"></div>
            <div class="card-data-logo">Maestro</div>
            <div class="card-data-number" id="card-data-number">**** **** **** ****</div>
            <div class="card-data-holder">
              <span class="card-data-label">Titular do cartão</span>
              <br>
              <span id="card-data-holder-name">{{dataCreditCard.cardName | uppercase}}</span>
            </div>
            <div class="card-data-expiry">
              <span class="card-data-label">Validade </span>
              <span id="card-data-expiry-date">{{dataCreditCard.cardMonth}}/{{dataCreditCard.cardYear}}</span>
            </div>
          </div>
          <div class="card-data-form">
            <label for="card-data-number-input">Número do cartão *:</label>
            <input
              type="text"
              id="card-data-number-input"
              placeholder="9999 9999 9999 9999"
              maxlength="19"
              [(ngModel)]="dataCreditCard.cardNumber"
            />
            <label for="card-data-holder-input">Titular do cartão *:</label>
            <input
              type="text"
              id="card-data-holder-input"
              placeholder="Rodrigo Nunes"
              [(ngModel)]="dataCreditCard.cardName"
            />
            <label for="card-data-expiry-month">Vencimento *:</label>
            <div class="card-data-expiry-container">
              <select id="card-data-expiry-month" [(ngModel)]="dataCreditCard.cardMonth">
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </select>
              <select id="card-data-expiry-year" [(ngModel)]="dataCreditCard.cardYear">
                <option *ngFor="let currentYear of years" [value]="currentYear">{{currentYear}}</option>
              </select>
            </div>
            <label for="card-data-cvv-input">CVV *:</label>
            <input
              type="text"
              id="card-data-cvv-input"
              placeholder="222"
              maxlength="3"
              [(ngModel)]="dataCreditCard.cardCvv"
            />
            <button id="card-data-subscribe-button" (click)="handleSubmitAssign()">ASSINAR</button>
          </div>
        </div>
        
      </div>
    </div>
  </div>


</div>

<app-loading-modal></app-loading-modal>
<app-alert></app-alert>